import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/hero";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => window.clearInterval(timer);
  }, []);

  const goTo = (index: number) => {
    setActive((index + heroSlides.length) % heroSlides.length);
  };

  return (
    <section className="w-full px-4 md:px-6 pt-6">
      <div className="relative w-full overflow-hidden rounded-xl h-[420px] md:h-[560px]">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <img
              src={slide.image}
              alt={`${slide.title} 焦点图`}
              title={`${slide.title} 影视推荐`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-black/25" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-transparent to-transparent" />

            <div className="absolute inset-0 flex items-end">
              <div className="w-full px-6 pb-12 md:px-12 md:pb-16 max-w-3xl">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                  <i className="ri-fire-fill text-sm"></i>
                  {slide.tag}
                </span>
                <h2 className="mt-4 text-3xl font-bold text-white font-heading md:text-5xl">
                  {slide.title}
                </h2>
                <p className="mt-3 max-w-xl text-sm text-white/85 md:text-base">
                  {slide.subtitle}
                </p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <Link
                    to={slide.link}
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-play-circle-line text-lg"></i>
                    查看详情
                  </Link>
                  <Link
                    to="/category/电视剧"
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-white/15 px-5 py-2.5 text-sm font-medium text-white ring-1 ring-white/30 backdrop-blur hover:bg-white/25 transition-colors cursor-pointer"
                  >
                    浏览剧集库
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        <button
          type="button"
          onClick={() => goTo(active - 1)}
          aria-label="上一张"
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/35 text-white backdrop-blur hover:bg-black/55 transition-colors cursor-pointer md:flex"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          type="button"
          onClick={() => goTo(active + 1)}
          aria-label="下一张"
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/35 text-white backdrop-blur hover:bg-black/55 transition-colors cursor-pointer md:flex"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        <div className="absolute bottom-5 right-6 flex items-center gap-2 md:right-12">
          {heroSlides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第 ${index + 1} 张`}
              onClick={() => goTo(index)}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                index === active
                  ? "w-7 bg-accent-500"
                  : "w-2 bg-white/50 hover:bg-white/80"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}